// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const isEncryptionSettingsData = objectOf({
  access_key_id: string,
  access_secret: string,
  hmac_key_id: string,
  auth_type: string,
  role_arn: string,
  external_id: string,
  account_id: string,
});

export const isGetUserDataEncryptionSettingsResult = objectOf({
  present: boolean,
  is_workspace_compatible: boolean,
  data: isEncryptionSettingsData,
});

export const isPostUserDataEncryptionSettingsResult = objectOf({
  info: string,
});

export const isGetGenerateExternalIdResult = objectOf({
  external_id: string,
  account_id: string,
});
